import React, { createContext } from 'react';

const MaterialInspectorContext = createContext();

export default MaterialInspectorContext;